import { getRoot, Instance, types } from 'mobx-state-tree';
import { DRAWER_DEFAULT_VALUES, DRAWER_POSITIONS, DRAWER_VIEWS, OpenDrawerParams } from './drawer.constants';
import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { IRootStore } from '../store';

export type DrawerInstance = Instance<typeof Drawer>;

export const Drawer = types
  .model({
    drawerVisible: types.boolean,
    drawerPosition: types.enumeration(Object.values(DRAWER_POSITIONS)),
    drawerView: types.enumeration(Object.values(DRAWER_VIEWS)),
    withBackdrop: types.boolean,
    drawerData: types.frozen(),
    openPoint: types.string,
  })
  .views(self => ({
    get root(): IRootStore {
      return getRoot<IRootStore>(self);
    },
  }))
  .volatile(self => {
    return {
      uploadButtonCallback: () => {},
    };
  })
  .actions(self => {
    return {
      closeDrawer: () => {
        self.drawerVisible = false;
        self.openPoint = '';
      },
      closeDrawerManual: () => {
        self.drawerVisible = false;
        const origin = self.openPoint.length ? { origin: self.openPoint } : {};
        amplitude.trackEvent(AnalyticsEvents.personalize.yourPhotoClose, {
          ...origin,
          context: self.root.project.activeGroup ? 'products_view' : 'groups_view',
        });
        self.openPoint = '';
      },
      openDrawer: (options: OpenDrawerParams) => {
        self.drawerView = options.drawerView ?? DRAWER_DEFAULT_VALUES.drawerView;
        self.drawerPosition = options.drawerPosition ?? DRAWER_DEFAULT_VALUES.drawerPosition;
        self.withBackdrop = options.withBackdrop ?? DRAWER_DEFAULT_VALUES.withBackdrop;
        self.uploadButtonCallback = options.uploadButtonCallback ?? (() => {});
        self.drawerData = options.drawerData ?? DRAWER_DEFAULT_VALUES.drawerData;
        self.openPoint = options.openPoint ?? DRAWER_DEFAULT_VALUES.openPoint;

        self.drawerVisible = true;
      },
    };
  });
